import { toast } from "react-toastify";

type NewsletterData = {
  email: string;
};

export const NewsletterService = {
  subscribe: async (data: NewsletterData): Promise<void> => {
    try {
      const apiUrl = process.env.REACT_APP_NEWSLETTER_API_URL;

      if (!apiUrl) throw new Error("API endpoint not configured");

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData?.message || "Subscription failed");
      }
    } catch (error) {
      toast.error(
        error instanceof Error ? error.message : "Subscription failed"
      );
      throw error;
    }
  },
};
